import React from "react";
import PFlogo from "images/logo-dark.png";
import loginBackground from "images/login/loginBackground.svg";
import styles from "./styles.module.scss";

export const starterLicencePlanIntegrations = () => {

  return (
    <>
    <div className={styles.content}>
      <div className={styles.container}>
        <img alt="Paperflite Logo" className={styles.logo} src={PFlogo} />
      </div>
      <h1 className={styles.heading}>Almost there! </h1>

      <div className={styles.contentContainer}>

          <p className={styles.description}>
            But it looks like you’ve got a Starter seat, which doesn’t cover the
            chrome extension.
        </p>    
            <p className={styles.subText}> Reach out to your admin for a quick seat upgrade.</p>
     

      </div>
      <div>
        <img
          alt="Half head man with audio waves in the background"
          className={styles.backgroundImage}
          src={loginBackground}
        />
      </div>
      </div>
    </>
  );
};

export default starterLicencePlanIntegrations;
